jQuery($ => {
	$('section.news .mobile-carousel').each(function () {
		const $carouselWrapper = $(this);
		$carouselWrapper.owlCarousel({
			margin: 24,
			items: 1.2,
			nav: false,
			loop: true,
			dots: false,
		});
	});
});
